/**
 * @file index.tsx
 *
 * @fileoverview Shows subgroups of a parent organization.
 */
import React from 'react';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { OrganizationTeaser } from '~/jobiqo/components/Organization/Teaser';
import { FormattedMessage } from 'react-intl';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface OrganizationSubGroupsProps {
  organization: OrganizationProfile;
}

export const OrganizationSubGroups = ({
  organization,
}: OrganizationSubGroupsProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const ORGANIZATION_PAGE_SHOW_CHILDREN =
    ORGANIZATIONS.ORGANIZATION_PAGE_SHOW_CHILDREN;

  return ORGANIZATION_PAGE_SHOW_CHILDREN &&
    organization?.isParent &&
    organization?.organizationProfiles &&
    organization?.organizationProfiles?.length > 0 ? (
    <div>
      <h2>
        <FormattedMessage
          id="organization_sub_groups"
          defaultMessage="Organizations"
        />
      </h2>
      <Spacing size="medium" />
      <Grid columns={[1, 2, 3, 4]}>
        {organization.organizationProfiles?.map((subOrganization) => {
          return (
            subOrganization && (
              <Cell key={subOrganization.id} display="grid">
                <OrganizationTeaser
                  key={subOrganization.id}
                  organization={subOrganization}
                />
              </Cell>
            )
          );
        })}
      </Grid>
    </div>
  ) : null;
};
